(function () {
  const sections = document.querySelectorAll('.swm26-ss2');
  if (!sections.length) return;

  const prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach((section) => {
    const animate = section.getAttribute('data-bullets-animate') === 'true';
    const bullets = Array.from(section.querySelectorAll('.swm26-ss2__bullets > .swm26-ss2__bullet'));

    if (!bullets.length) return;

    if (!animate || prefersReduced) {
      bullets.forEach((li) => li.classList.add('is-in'));
      return;
    }

    const reveal = () => {
      bullets.forEach((li) => li.classList.remove('is-in'));
      bullets.forEach((li, idx) => {
        setTimeout(() => li.classList.add('is-in'), 80 + idx * 120);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          requestAnimationFrame(() => {
            requestAnimationFrame(reveal);
          });
          observer.disconnect();
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(section);
  });
})();